/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldEditor} from "./BaseFieldEditor";
import {service as UserRoleService} from "../../../Services/UserRoleService";
import autobind from "autobind-decorator";
import {FormControl} from "react-bootstrap";
import React from "react";

export class UserRoleFieldEditor extends BaseFieldEditor {
	constructor(props) {
		super(props)

		this.setInitialState({
			roles: []
		});
	}

	componentDidMount() {
		UserRoleService.Get()
			.then((x) => {
				this.setState({roles: x.result});
			});
	}

	@autobind
	_render() {
		return <FormControl
			as="select"
			placeholder="Select User Role"
			value={this.props.Value != null ? this.props.Value : ""}
			onChange={(x) => this.props.OnUpdate(x.target.value)}
		>
			<option value="">Select User Role</option>
			{
				this.state.roles.map((x) => <option key={x.userRoleId} value={x.userRoleId}>{x.name}</option>)
			}
		</FormControl>;
	}
}